import { Navigate } from 'react-router-dom';
import { useMfaSession } from '../features/auth';

interface MfaPendingGuardProps {
  children: React.ReactNode;
}

export function MfaPendingGuard({ children }: MfaPendingGuardProps) {
  const { mfaSessionToken } = useMfaSession();

  if (!mfaSessionToken) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
